import React from 'react'
import PropTypes from 'prop-types'
import { majorScale, Pane } from 'evergreen-ui'
import Step from './Step'

export default class Steps extends React.PureComponent {
  static propTypes = {
    /**
     * A list of steps that will be shown consecutively.
     */
    steps: PropTypes.array,

    /**
     * The current step index is used to highlight the correct step.
     */
    step: PropTypes.number,

    /**
     * Used to indicate what the highest accesible step is.
     */
    accessibleStep: PropTypes.number,

    /**
     * When true, the steps are all disabled.
     */
    disabled: PropTypes.bool,

    /**
     * Passes both the stepIndex and label with signature (stepIndex).
     * Fired only when a accessible step is clicked.
     */
    onSelect: PropTypes.func
  }

  render() {
    const {
      steps,
      step: currentStep,
      accessibleStep,
      disabled,
      onSelect
    } = this.props

    return (
      <Pane
        display="flex"
        alignItems="center"
        justifyContent="center"
        height={majorScale(3)}
      >
        {steps.map((step, index) => (
          <Step
            key={`step-${step.id}`}
            step={index + 1}
            isActive={step.id === currentStep}
            isAccessible={disabled ? false : step.id <= accessibleStep}
            onClick={disabled ? null : onSelect.bind(null, step.id)}
          >
            {step.label}
          </Step>
        ))}
      </Pane>
    )
  }
}
